import React from 'react'
import { Form, Input, DatePicker, Checkbox, Divider, Select, InputNumber } from 'antd'
import { Message } from 'semantic-ui-react';

class ProviderPayment extends React.Component {
  render() {
    return (
      <Form name="provider-payment">
        <Form.Item label="Provider Invoice No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Provider Invoice No">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Amount (excl GST)">
          <InputNumber 
            size="large" 
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GST">
          <InputNumber 
            size="large" 
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Attach Provider Invoice" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Email Invoice to Operator</Checkbox>
        </div>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Prepayment Required</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 3
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Prepayment Required Date">
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Prepayment Paid</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 4
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Payment Date" required>
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Attach Provider Invoice" className="fluid-field">
          <Message className="upload-box">
            <div className="upload-file">
              <input type="file" /> Click here to upload
            </div>
          </Message>
        </Form.Item>
        <Form.Item label="Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Email Payment Receipt to Provider</Checkbox>
        </div>
      </Form>
    )
  }
}

export default ProviderPayment